module.exports = __webpack_public_path__ + "statics/img/income-card-2.575e4ef9.png";